import React from "react";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  size?: "sm" | "md" | "lg";
}

export function Modal({ open, onClose, title, children, size = "md" }: ModalProps) {
  if (!open) return null;

  const maxWidth = {
    sm: "max-w-sm",
    md: "max-w-lg",
    lg: "max-w-2xl",
  }[size];

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ backgroundColor: "color-mix(in srgb, var(--c-bg) 70%, transparent)" }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className={`${maxWidth} w-full rounded-xl p-6`}
        style={{
          backgroundColor: "var(--c-surface)",
          border: "1px solid var(--c-border)",
          boxShadow: "0 25px 50px -12px color-mix(in srgb, var(--c-text) 25%, transparent)",
        }}
      >
        {title && (
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-sm font-semibold" style={{ color: "var(--c-text)" }}>
              {title}
            </h2>
            <button
              onClick={onClose}
              className="p-1 rounded-lg transition-colors duration-200"
              style={{ color: "var(--c-text-faint)" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "var(--c-text-secondary)")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "var(--c-text-faint)")}
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M3 3l8 8M11 3l-8 8" />
              </svg>
            </button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
